export default [
  {
    id: 1,
    requestId: "FZE825876854",
    partners: "BEDQUARTER...",
    showroom: "BQ-ALHASA",
    type: "SHR",
    createDate: "05-07-2023",
    assignee: "Admin",
    status: "Open",
  },
  {
    id: 2,
    requestId: "FZE825876854",
    partners: "BEDQUARTER...",
    showroom: "BQ-ALHASA",
    type: "SHR",
    createDate: "05-07-2023",
    assignee: "Admin",
    status: "Review",
  },
  {
    id: 3,
    requestId: "FZE825876854",
    partners: "BEDQUARTER...",
    showroom: "BQ-ALHASA",
    type: "SHR",
    createDate: "05-07-2023",
    assignee: "Admin",
    status: "In Progress SP",
  },
  {
    id: 4,
    requestId: "FZE825876854",
    partners: "BEDQUARTER...",
    showroom: "BQ-ALHASA",
    type: "SHR",
    createDate: "05-07-2023",
    assignee: "Admin",
    status: "In Progress IKD",
  },
  {
    id: 5,
    requestId: "FZE825876854",
    partners: "BEDQUARTER...",
    showroom: "BQ-ALHASA",
    type: "SHR",
    createDate: "05-07-2023",
    assignee: "Admin",
    status: "Completed",
  },
];
